import React from 'react';
import App from 'next/app';
import Head from 'next/head';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from 'shared/style/global';
import CookiesStyle from 'shared/style/cookies';
import MobileStyle from 'shared/style/mobile';
import theme from 'shared/style/theme';
import { fetchLanguages } from 'shared/utils/prismic';
import { loadExternalScripts } from 'shared/utils/scriptIntegrations';
import SnackbarProvider from 'react-simple-snackbar';

import 'tailwindcss/tailwind.css';
import '../v2/styles.css';
import '../../public/tailwind.css';

class MyApp extends App {
  static async getInitialProps(props) {
    const {
      Component,
      ctx,
      ctx: {
        query,
        query: { lang, id },
      },
    } = props;

    const isServer = !!ctx.req;

    let languages = [];
    if (isServer) {
      languages = await fetchLanguages();
    } else {
      ({ languages } = window.__NEXT_DATA__.props);
    }

    const currentLanguage = languages.find(l => l.value === lang);

    let pageProps = {};
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps({
        ctx,
        lang: currentLanguage ? currentLanguage.id : 'en-us',
        pageId: id,
        query,
        languages,
      });
    }

    return { pageProps, languages };
  }

  componentDidMount() {
    loadExternalScripts();
  }

  render() {
    const { Component, pageProps } = this.props;

    return (
      <>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Montserrat" />
        </Head>

        <CookiesStyle />
        <GlobalStyle />
        <MobileStyle />
        <ThemeProvider {...{ theme }}>
          <SnackbarProvider>
            <Component {...pageProps} />
          </SnackbarProvider>
        </ThemeProvider>
      </>
    );
  }
}

export default MyApp;
